export const disableContentSlider = [
  '',
  `mutation disableContentSlider($id:Int!) {
    disableContentSlider(id:$id)
      }
    `,
  'disableContentSlider'];
